import type { FiltersType } from '@customTypes/filters';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

type Props = {
  onParamsChange: (filters: FiltersType) => void;
};

const usePaginationParams = ({ onParamsChange }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const paramsObj = Object.fromEntries(searchParams.entries());
    const page = Number(paramsObj.page) || 1;
    const limit = Number(paramsObj.limit) || 10;

    if (!paramsObj.page || !paramsObj.limit) {
      const newParams = new URLSearchParams(searchParams);
      if (!paramsObj.page) newParams.set('page', String(page));
      if (!paramsObj.limit) newParams.set('limit', String(limit));
      setSearchParams(newParams);
      return;
    }

    onParamsChange({ ...paramsObj, page, limit });
  }, [searchParams, onParamsChange]);
};

export default usePaginationParams;
